import { Form, Card, Flex, InputNumber, Radio } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { useWizardContext } from "../../../WizardContext"
import styles from "./PaymentType.module.css"

const PAYMENT_TYPES = {
  FULL: "full",
  DEPOSIT: "deposit",
}

const PaymentType = () => {
  const { t } = useTranslation()
  const { form } = useWizardContext()
  const paymentType = Form.useWatch("payment_type", form)
  const isDeposit = paymentType === PAYMENT_TYPES.DEPOSIT

  return (
    <Card>
      <Text className={styles.sectionTitle}>{t("experiences.pricing.payment_type.title")}</Text>
      <Flex vertical gap={16}>
        <Form.Item name="payment_type" initialValue={PAYMENT_TYPES.FULL} noStyle>
          <Radio.Group>
            <Flex vertical gap={8}>
              <Radio value={PAYMENT_TYPES.FULL}>{t("experiences.pricing.payment_type.full")}</Radio>
              <Radio value={PAYMENT_TYPES.DEPOSIT}>{t("experiences.pricing.payment_type.deposit")}</Radio>
            </Flex>
          </Radio.Group>
        </Form.Item>

        {isDeposit && (
          <Flex vertical gap={4}>
            <Text className={styles.depositLabel}>
              {t("experiences.pricing.payment_type.deposit_label")}
              <span className={styles.required}>{"*"}</span>
            </Text>
            <Form.Item name="deposit_percentage" initialValue={10} noStyle>
              <InputNumber
                min={10}
                max={99}
                suffix="%"
                className={styles.depositInput}
                size="large"
              />
            </Form.Item>
          </Flex>
        )}
      </Flex>
    </Card>
  )
}

export default PaymentType
